// extracted by mini-css-extract-plugin
module.exports = {"container":"MainScreen_container__1yI0Y","content":"MainScreen_content__S3pms","logo":"MainScreen_logo__3MQ8n","hide":"MainScreen_hide__YsVKB","waves":"MainScreen_waves__1HBhY"};